'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssComponent = require('react-css-component');

var _LineupCardHeader = require('./LineupCardHeader');

var _LineupCardHeader2 = _interopRequireDefault(_LineupCardHeader);

var _LineupCardRowHeader = require('./LineupCardRowHeader');

var _LineupCardRowHeader2 = _interopRequireDefault(_LineupCardRowHeader);

var _LineupCardRow = require('./LineupCardRow');

var _LineupCardRow2 = _interopRequireDefault(_LineupCardRow);

var _LineupCardTimeRemaining = require('./LineupCardTimeRemaining');

var _LineupCardTimeRemaining2 = _interopRequireDefault(_LineupCardTimeRemaining);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var css = '\n.lineup-card-container-full {\n  padding: 5px;\n}\n.lineup-card-container-condensed {\n  padding: 0;\n  border-bottom: 1px solid #ccc;\n}\n.lineup-card {\n  box-shadow: 0 3px 2px -2px #ccc;\n  background-color: #fff;\n}\n.padding-5 {\n  padding: 5px;\n}\n.display-table {\n  display: table;\n  width: 100%;\n}\n';
var getBgColor = function getBgColor(te) {
    if (te < 40) {
        return 'success';
    } else if (te < 70) {
        return 'warning';
    } else if (te < 100) {
        return 'danger';
    }
    return 'gray';
};

var LineupCard = function LineupCard(props) {
    var display = _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_reactCssComponent.UniversalStyle, { css: css }),
        _react2.default.createElement(
            'div',
            {
                key: props.lineup.lineup_id,
                className: props.viewFullLineupCard ? 'lineup-card-container-full' : 'lineup-card-container-condensed'
            },
            props.viewFullLineupCard ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_LineupCardTimeRemaining2.default, { lineup: props.lineup, color: getBgColor(props.lineup.time_elapsed) }),
                _react2.default.createElement(
                    'div',
                    { className: props.viewFullLineupCard ? 'lineup-card padding-5' : 'lineup-card' },
                    _react2.default.createElement(_LineupCardHeader2.default, {
                        sport: props.sport,
                        lineup: props.lineup,
                        viewFullLineupCard: props.viewFullLineupCard,
                        lineupIdx: props.lineupIdx,
                        sortLineups: props.sortLineups,
                        handleLineupClick: props.handleLineupClick,
                        selectedLineup: props.selectedLineup,
                        viewPlayersInLineups: props.viewPlayersInLineups,
                        color: getBgColor(props.lineup.time_elapsed)
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: 'display-table' },
                        _react2.default.createElement(_LineupCardRowHeader2.default, { sport: props.sport, lineup: props.lineup }),
                        props.lineup.lineup_players.map(function (player) {
                            return _react2.default.createElement(_LineupCardRow2.default, {
                                key: player.fantasy_result_id,
                                pos: player.position,
                                player: player,
                                sport: props.sport,
                                lineup: props.lineup
                            });
                        })
                    )
                )
            ) : _react2.default.createElement(
                'div',
                { className: 'lineup-card' },
                _react2.default.createElement(_LineupCardHeader2.default, {
                    sport: props.sport,
                    lineup: props.lineup,
                    viewFullLineupCard: props.viewFullLineupCard,
                    lineupIdx: props.lineupIdx,
                    handleLineupClick: props.handleLineupClick,
                    selectedLineup: props.selectedLineup,
                    viewPlayersInLineups: props.viewPlayersInLineups,
                    sortLineups: props.sortLineups
                })
            )
        )
    );
    return display;
};

exports.default = LineupCard;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/lineups/LineupCard.js
// module id = 801
// module chunks = 0